import { render, staticRenderFns } from "./readbook.vue?vue&type=template&id=49fe1f93&scoped=true"
import script from "./readbook.vue?vue&type=script&lang=js"
export * from "./readbook.vue?vue&type=script&lang=js"
import style0 from "./readbook.vue?vue&type=style&index=0&id=49fe1f93&prod&lang=css"
import style1 from "./readbook.vue?vue&type=style&index=1&id=49fe1f93&prod&scoped=true&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fe1f93",
  null
  
)

export default component.exports